<template>
  <div>
    <Row type="flex" :space-x="10" class="margin-bottom">
      <Cell :flex="1">
        <div class="h-input-group" v-width="350">
          <DatePicker v-model="filter.startDate" style="width: 140px" :clearable="false" 
                      :option="{end:filter.endDate}" format="YYYY-MM-dd"/>
          <span class="h-input-addon">至</span>
          <DatePicker v-model="filter.endDate" style="width: 140px" :clearable="false" 
                      :option="{start:filter.startDate}" format="YYYY-MM-dd"/>
        </div>
        <Select v-model="filter.billType" :datas="billTypeList" key-name="id" title-name="name" 
                :null-option="{title: '全部类型'}" style="width: 120px; margin-left: 10px"/>
      </Cell>
      <Cell>
        <Button color="primary" @click="loadData" icon="fa fa-search">查询</Button>
      </Cell>
    </Row>
    <Table :datas="recordList" :loading="loading" :columns="columns">
      <template v-slot:billType="{data}">
        <span :class="data.billType === 1 ? 'green-color' : 'red-color'">
          {{ data.billType === 1 ? '入库' : '出库' }}
        </span>
      </template>
      <template v-slot:bizType="{data}">
        {{ getBizTypeName(data.bizType) }}
      </template>
    </Table>
  </div>
</template>

<script>
import inventory from '@/api/inventory';
import manba from 'manba';

export default {
  name: "InventoryRecord",
  props: {
    accountSetsId: Number
  },
  data() {
    return {
      loading: false,
      recordList: [],
      filter: {
        startDate: manba().startOf(manba.MONTH).format(),
        endDate: manba().endOf(manba.MONTH).format(),
        billType: null
      },
      billTypeList: [
        { id: 1, name: '入库' },
        { id: 2, name: '出库' }
      ],
      columns: [
        { title: '单据编号', key: 'billNo', width: 150 },
        { title: '单据日期', key: 'billDate', width: 120 },
        { title: '类型', slot: 'billType', width: 80 },
        { title: '业务类型', slot: 'bizType', width: 100 },
        { title: '数量', key: 'quantity', width: 100 },
        { title: '单价', key: 'unitPrice', width: 100 },
        { title: '金额', key: 'amount', width: 120 },
        { title: '仓库', key: 'warehouse', width: 100 },
        { title: '供应商/客户', key: 'supplierName', width: 150 },
        { title: '摘要', key: 'digest' },
        { title: '经办人', key: 'operator', width: 100 }
      ]
    };
  },
  watch: {
    accountSetsId: {
      immediate: true,
      handler(val) {
        if (val) {
          this.loadData();
        }
      }
    }
  },
  methods: {
    loadData() {
      this.loading = true;
      inventory.record.listByDateRange(this.accountSetsId, this.filter.startDate, this.filter.endDate)
        .then(res => {
          let list = res.data || [];
          if (this.filter.billType) {
            list = list.filter(item => item.billType === this.filter.billType);
          }
          this.recordList = list;
        })
        .catch(() => {
          this.recordList = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getBizTypeName(bizType) {
      const map = {
        'Purchase': '采购入库',
        'Sale': '销售出库',
        'Return': '退货',
        'Adjust': '调整',
        'Check': '盘点'
      };
      return map[bizType] || bizType;
    }
  }
};
</script>
